export default "__VITE_ASSET__c813f475__"